import { InjectionToken } from '@angular/core';
import { Theme } from './theming';

export const DEFAULT_THEME = new InjectionToken<Theme>('Epdk default theme');